import { GitBranch } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { ApprovalWorkflowManager } from "./ApprovalWorkflowManager";

export function WorkflowsPage() {
  return (
    <div>
      <PageHeader
        icon={GitBranch}
        title="Approval Workflows"
        description="Define multi-step approval chains for your content. Set which team members must sign off before a post can be published, and whether steps are sequential or parallel."
      />
      <ApprovalWorkflowManager />
    </div>
  );
}
